<template>
  <div class="nc-progress" :class="{ 'nc-progress--labeled': label }">
    <div v-if="label" class="nc-progress__header">
      <span class="nc-progress__label">{{ label }}</span>
      <span v-if="showValue" class="nc-progress__value">{{ Math.round(value * 100) }}%</span>
    </div>
    <div class="nc-progress__track" :style="{ height: height + 'px' }">
      <div
        class="nc-progress__fill"
        :class="'nc-progress__fill--' + color"
        :style="{ width: Math.min(Math.max(value, 0), 1) * 100 + '%' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NcProgressBar',
  props: {
    value: { type: Number, default: 0 },
    color: { type: String, default: 'primary' },
    label: { type: String, default: '' },
    showValue: { type: Boolean, default: false },
    height: { type: Number, default: 4 },
  },
};
</script>

<style scoped>
.nc-progress { width: 100%; }
.nc-progress--labeled { padding: 0 4px; }
.nc-progress__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.nc-progress__label { font-size: 12px; font-weight: 500; color: var(--nc-text-secondary, #92949c); }
.nc-progress__value { font-size: 12px; font-weight: 600; color: var(--nc-text, #1a1a2e); }
.nc-progress__track {
  width: 100%;
  background: var(--nc-bg-input, #eef2f8);
  border-radius: 99px;
  overflow: hidden;
}
.nc-progress__fill {
  height: 100%;
  border-radius: 99px;
  transition: width 0.3s ease;
}
.nc-progress__fill--primary { background: var(--nc-color-primary, #14b69a); }
.nc-progress__fill--success { background: var(--nc-color-success, #14b69a); }
.nc-progress__fill--warning { background: #ffc409; }
.nc-progress__fill--danger { background: var(--nc-color-danger, #eb445a); }
.nc-progress__fill--medium { background: var(--nc-text-muted, #92949c); }
</style>
